import { useAtom } from 'jotai';
import { brandFilterModeAtom } from '~/atoms';
import { BrandFilterMode } from '~/types/common';

/*
 * PageLayout 의 brandFilterMode prop 으로 설정 가능합니다.
 * 기본적으로 PageLayout 의 속성을 활용하되, 예외 케이스에서만 직접 호출하세요.
 */
export const useBrandFilterMode = (params?: { nextMode: BrandFilterMode }) => {
  const [brandFilterMode, setBrandFilterMode] = useAtom(brandFilterModeAtom);

  if (params?.nextMode === 'enabled' && brandFilterMode !== 'enabled') {
    setBrandFilterMode('enabled');
  }
  if (params?.nextMode === 'disabled' && brandFilterMode !== 'disabled') {
    setBrandFilterMode('disabled');
  }
  if (params?.nextMode === 'all' && brandFilterMode !== 'all') {
    setBrandFilterMode('all');
  }

  return {
    brandFilterMode,
  };
};
